const stepper = state => state.stepper;
const done = state => state.stepper?.done;
const currentStage = state => state.stepper?.currentStage;

export { currentStage, done, stepper };
